import React from "react";

export function HamburgerIcon({ fill = "currentColor", width = 24, height = 24, ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill={fill}
      width={width}
      height={height}
      style={{ display: "block", flexShrink: 0 }}
      {...props}
    >
      <path d="M 3 5 A 1.0001 1.0001 0 1 0 3 7 L 21 7 A 1.0001 1.0001 0 1 0 21 5 L 3 5 z M 3 11 A 1.0001 1.0001 0 1 0 3 13 L 21 13 A 1.0001 1.0001 0 1 0 21 11 L 3 11 z M 3 17 A 1.0001 1.0001 0 1 0 3 19 L 21 19 A 1.0001 1.0001 0 1 0 21 17 L 3 17 z" />
    </svg>
  );
}

export function ChevronLeftIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      width="1.25em"
      height="1.25em"
      {...props}
    >
      <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
    </svg>
  );
}

export function ChevronRightIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      width="1.25em"
      height="1.25em"
      {...props}
    >
      <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" />
    </svg>
  );
}
